import { ChangeDetectionStrategy, Component, Input, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

import { I18nService, TranslatePipe } from '@recruitee/i18n';
import {
  DialogService,
  DialogWidth,
  IconComponent,
  IconColorDirective,
  MessageComponent,
} from '@recruitee/user-interface';

import { OffersArchiveDialogComponent } from './offers-archive-dialog/offers-archive-dialog.component';

@Component({
  selector: 'rt-job-slots-limit-message',
  templateUrl: './job-slots-limit-message.component.html',
  styleUrls: ['./job-slots-limit-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MessageComponent, IconColorDirective, IconComponent, TranslatePipe],
})
export class JobSlotsLimitMessageComponent {
  @Input() public numberOfJobsToArchive: number;
  @Input() public compact: boolean;
  @Input() public altMessage?: string;

  public message: string;

  constructor(
    private router: Router,
    private i18n: I18nService,
    private dialogSvc: DialogService,
    private vcRef: ViewContainerRef,
  ) {}

  public ngOnChanges() {
    if (this.numberOfJobsToArchive > 0) {
      this.message = this.i18n.translate(
        'app.pricing.job_slots_dialog.slots_downgrade_limit_jobs',
        {
          jobs: this.numberOfJobsToArchive,
        },
      );
    } else {
      this.message = '';
    }
  }

  public manageOffers() {
    this.dialogSvc.custom(
      OffersArchiveDialogComponent,
      {
        width: DialogWidth.Small,
      },
      null,
      this.vcRef,
    );
  }
}
